import ItensMenu from './ItensMenu';
import './Sidebar.css';
import SidebarFooter from './SidebarFooter';
import SidebarHeader from './SidebarHeader';

const SidebarAdmin = (props) => {
    const { close } = props;
    
    return(
        <aside className={`sidebar ${close ? "collapsed" : ""}`} id="sidebar">
            
            <SidebarHeader />

            <nav className="sidebar-menu">
                
                <ItensMenu active={props.dashboardActive} icone="📊" nome="Dashboard Admin" link="/admin/dashboard"/>
                <ItensMenu active={props.usuariosActive} icone="👥" nome="Usuarios / Licenciados" link="/usuarios"/>
                <ItensMenu active={props.comissaoActive} icone="💼" nome="Lancamentos de comissao" link="/lancarcomissao"/>
                <ItensMenu icone="💰" nome="Pedidos de saque" link="/embreve"/>
                <ItensMenu active={props.logsActive} icone="🧾" nome="Logs" link="/logs"/>
                
            </nav>

            <SidebarFooter />
        </aside>
    );
};

export default SidebarAdmin;
